import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M54 48H12c-1.1 0-2-.9-2-2V27.19l21.92 5.88L54 27.15V48l4-1.07V22h-6V6H12v16H6v24c0 3.31 2.69 6 6 6h43.07L54 48ZM15 9h34v17.42L31.92 31 15 26.46V9Z"
      }
    )
  }
);
export {
  t as OpenLetter
};
